import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';

var SvgFji = function SvgFji(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
    fill: "#2C97DE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0Z",
    fill: "#227FBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.288 2.402 8 6.114 14.065.05A56.78 56.78 0 0 1 16 0v1.886L9.886 8 16 14.114V16h-1.886L8 9.886 1.886 16H.003v-.017c-.008-.614 0-1.249.027-1.898L6.114 8 2.467 4.353a9.023 9.023 0 0 1 1.821-1.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.555.031C15.035.015 15.518.004 16 0L8.472 7.529l-.708-.708 6.791-6.79ZM3.308 3.307l4.22 4.222-.706.707-4.157-4.157c.194-.26.408-.52.643-.772ZM.003 16v-.003L7.53 8.47l.707.708L1.414 16H.004Zm8.469-7.529.707-.707L16 14.586V16L8.472 8.471Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 .399V16H6V1.372c.112-.05.226-.097.342-.143C7.272.875 8.544.6 10 .4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.529 6H16v4H.442a30.35 30.35 0 0 1 .424-2.125s.169-.803.663-1.875Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.334.498V16H6.667V1.114C7.403.867 8.312.662 9.334.498Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.246 6.667H16v2.666H.558c.09-.485.193-.972.308-1.458 0 0 .102-.487.38-1.208Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 10v8.545C19 21.34 24 23 24 23s5-1.66 5-4.455V10H19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.307 13.365v3.46H19v1.406h4.307v4.502L24 23l.693-.267V18.23H29v-1.405h-4.307v-3.461H29V10H19v3.365h4.307Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.28 11.137c0 .148.099.277.241.315l.566.15a.5.5 0 0 0 .245.002l2.456-.592a.477.477 0 0 1 .08-.012l.6-.04a.18.18 0 1 0-.054-.357l-1.93.463a.5.5 0 0 1-.27-.01l-.34-.11a.287.287 0 0 0-.29.07.288.288 0 0 1-.424-.02l-.189-.227a.114.114 0 0 1-.026-.073c0-.119.16-.158.215-.053l.004.009c.026.05.084.073.137.056l.49-.153a.5.5 0 0 1 .284-.004l.546.152a.5.5 0 0 0 .245.007l1.812-.41a.5.5 0 0 1 .48.15l.163.178a.343.343 0 0 1-.133.553l-.136.051a.264.264 0 0 0 .093.51h.438a.5.5 0 0 1 .436.256l.087.155a.496.496 0 0 1-.227.694l-.103.048a.199.199 0 0 1-.142.009l-.078-.025a.172.172 0 0 1-.005-.326.172.172 0 0 0 .085-.26l-.004-.006a.177.177 0 0 0-.184-.072l-.491.11a.5.5 0 0 1-.174.007l-.768-.102a.145.145 0 0 0-.143.218.145.145 0 0 1-.057.204l-.774.403a.5.5 0 0 1-.332.046l-.289-.06a.323.323 0 0 1-.257-.316c0-.2-.179-.351-.376-.319l-1.263.21a.502.502 0 0 1-.082.007h-.94a.5.5 0 0 0-.262.074l-.518.316a.5.5 0 0 1-.425.046l-.616-.214a.357.357 0 1 1 .365-.596l.194.186a.425.425 0 0 0 .716-.355l-.02-.176a.5.5 0 0 0-.274-.39l-.197-.1a.418.418 0 0 0-.368-.002l-.092.044a.275.275 0 0 1-.247-.49l.161-.085a.41.41 0 0 1 .293-.034l.582.151a.5.5 0 0 0 .57-.255l.1-.193a.143.143 0 0 0 .015-.065v-.025c0-.12.148-.18.23-.092.04.043.104.054.156.029l.072-.035a.22.22 0 0 1 .314.156l.015.077a.108.108 0 0 0 .088.086.108.108 0 0 1 .029.204l-.036.017a.12.12 0 0 0-.067.108v.127Z",
    fill: "#F2C500"
  }));
};

export default SvgFji;